import { Row } from 'antd';
import styled from 'styled-components';
import TextBoxWithTooltip from '~src/components/TextBoxWithTooltip/TextBoxWithTooltip';

import TileHeader from '~src/shared/headers/tileHeader/TileHeader';
import { PageContentContainer, TileContainer } from '~src/styles/containers.sc';

export const ScalePageContainer = styled(PageContentContainer)`
  padding-top: 30px;
`;

export const ScaleTileContainer = styled(TileContainer)<{ $isCountAboveFour: boolean }>`
  margin-top: 60px;

  ${({ $isCountAboveFour }) =>
    $isCountAboveFour &&
    `
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    padding-right: 2rem;
  `}
`;

export const CheckboxContainer = styled.div`
  min-height: 50px;
`;

export const ComponentContainer = styled.div`
  padding: 30px 30px 20px;
  position: relative;
  min-height: 100px;
  width: 100%;
`;

export const StyledTextBoxWithTooltip = styled(TextBoxWithTooltip)`
  width: 200px;
  padding: 12px;
  text-align: center;
`

export const AddLabelLnk = styled.button<{ $disabled: boolean }>`
  background: none;
  border: none;
  position: absolute;
  left: 30px;
  top: 30px;
  z-index: 99;
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: 1rem;
  text-decoration: underline;
  cursor: pointer;
  ${({ $disabled, theme }) =>
    $disabled &&
    `
    color: ${theme.baseBlue.a6};
    opacity: 0.5;
    cursor: default;
  `}

  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
    ${({ $disabled, theme }) =>
      $disabled &&
      `
      color: ${theme.baseBlue.a6};
    `};
  }
`;

export const CustomScaleStatesContainer = styled.div`
  padding-top: 69px;
`;

export const NpsStarsScaleStatesContainer = styled.div`
  padding-top: 43px;
`;

export const DelBtn = styled.button`
  width: 15px;
  height: 15px;
  border: 0;
  margin-left: 10px;
  opacity: 0.5;
  background: none;
  padding: 0;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
  &:focus {
    outline: none;
  }
`;

export const ScaleStateBox = styled.div`
  margin: 5px 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:hover ${DelBtn} {
    display: block;
  }
`;

export const ScaleInfo = styled.div<{ $isCountAboveFour: boolean }>`
  ${({ $isCountAboveFour }) =>
    $isCountAboveFour &&
    `
    width: 22rem;
    padding-top: 4px;

    .hl3 {
      font-size: 18px;
    }
 `}
`;

export const ScaleRow = styled(Row).attrs({ gutter: 30 })`
  width: 100%;
`;

export const ScaleTilePreviewHeader = styled(TileHeader)<{ $isCountAboveFour: boolean }>`
  margin-top: 3.3rem;
`;
